export enum IntegrationType {
  Xero = "Xero",
}

// Mirrors the backend's XeroSyncDatapoint (agrinous_xero/constants.py), minus
// ALL (handled by omitting the data_point param) and DOCUMENTS (synced via
// its own dedicated sync-documents action).  And minus create-tax-rates that is a one off and
// should be done when connecting via ALL.
export enum XeroSyncDatapoint {
  Organisations = "organisations",
  TaxRates = "tax-rates",
  LedgerAccounts = "ledger-accounts",
  TrackingCategories = "tracking-categories",
  Businesses = "businesses",
  ContactGroups = "contact-groups",
  StatementCredits = "statement-credits",
}

export const XeroSyncDatapointLabels: Record<XeroSyncDatapoint, string> = {
  [XeroSyncDatapoint.Organisations]: "Sync Organisations",
  [XeroSyncDatapoint.TaxRates]: "Sync Tax Rates",
  [XeroSyncDatapoint.LedgerAccounts]: "Sync Ledger Accounts",
  [XeroSyncDatapoint.TrackingCategories]: "Sync Tracking Categories",
  [XeroSyncDatapoint.Businesses]: "Sync Businesses",
  [XeroSyncDatapoint.ContactGroups]: "Sync Contact Groups",
  [XeroSyncDatapoint.StatementCredits]: "Sync Statement Credits",
};
